/**
 * The sync config key used to store the Match Booster targeting level.
 * When not set, defaults to person-level targeting
 *
 * Note: The sync config keys gets cleaned in `convertSync` to camelCase.
 * so need to use camelCase and remove underscores
 */
export const MATCH_BOOSTER_TARGET_LEVEL_CONFIG_KEY =
  "htMatchBoosterTargetLevel";

/**
 * Global cap on Match Booster enrichment schedules, in days.
 *
 * Sized against the EU enrichment pipeline's 30-day TTL (Snowflake task drops
 * stale `ENRICHED_RESULTS_*` tables + S3 lifecycle). The cap sits 2 days
 * below the TTL so an enrichment scheduled at the boundary has time to start
 * and finish before its output tables are dropped. The same cap is applied to
 * every region so the FE contract is uniform. Enforcement is frontend-only
 * (`isScheduleOverTTL` blocks over-cap saves); the backend does not clamp, so
 * already-configured schedules keep running at their cadence (grandfathered).
 */
export const MAX_ENRICHMENT_INTERVAL_DAYS = 28;

/**
 * Convert a schedule interval to days. The unit values are the enum string
 * values shared between frontend (`ScheduleIntervalUnit`) and backend
 * (`IntervalUnit`): "minute" | "hour" | "day" | "week".
 */
export function scheduleIntervalToDays(
  unit: string | undefined,
  quantity: number,
): number {
  switch (unit) {
    case "minute":
      return quantity / (60 * 24);
    case "hour":
      return quantity / 24;
    case "day":
      return quantity;
    case "week":
      return quantity * 7;
    default:
      throw new Error(`Unknown schedule interval unit: ${unit}`);
  }
}
